'use strict';

require('../less/about_us.less');

(function () {
    // 设置active
    $($('.about-us-tabs').find('span').removeClass('active')[1]).addClass('active');
    // 根据url匹配iframe高度
    var pathname = window.location.pathname;
    var height = '';
    switch (pathname) {
        case '/investorroom':
        case '/investorroom/corporate-profile':
            // Sunlands InvestorRoom（即投资关系页面，显示corportate profile的链接内容）
            height = '1000px';
            break;
        case '/investorroom/management':
            // Management - Sunlands InvestorRoom
            height = '1600px';
            break;
        case '/investorroom/board-of-directors':
            // Board of Directors - Sunlands
            height = '3000px';
            break;
        case '/investorroom/committee-composition':
            // Committee Composition - Sunlands InvestorRoom
            height = '800px';
            break;
        case '/investorroom/corporate-governance':
            // Corporate Governance - Sunlands InvestorRoom
            height = '1000px';
            break;
        case '/investorroom/sec-filings':
            // SEC Filings - Sunlands InvestorRoom
            height = '1000px';
            break;
        case '/investorroom/financial-reports':
            // Financial Reports - Sunlands InvestorRoom
            height = '600px';
            break;
        case '/investorroom/analyst-coverage':
            // Analyst Coverage - Sunlands InvestorRoom
            height = '600px';
            break;
        case '/investorroom/stock-quote-chart':
            // Stock Quote & Chart - Sunlands InvestorRoom
            height = '600px';
            break;
        case '/investorroom/press-releases':
            // Press Releases - Sunlands InvestorRoom
            height = '800px';
            break;
        case '/investorroom/event-calendar':
            // Event Calendar - Sunlands InvestorRoom
            height = '800px';
            break;
        case '/investorroom/webcasts-and-presentations':
            // Webcasts and Presantations - Sunlands InvestorRoom
            height = '1000px';
            break;
        case '/investorroom/ir-contacts':
            // IR Contacts - Sunlands InvestorRoom
            height = '600px';
            break;
        case '/investorroom/email-alerts':
            // Email Alerts - Sunlands InvestorRoom
            height = '600px';
            break;
        case '/investorroom/contact-information':
            // FAQ - Sunlands InvestorRoom
            height = '800px';
            break;
        default:
            height = '1000px';
            break;
    }
    $('#investor_frame').css('height', height);
})();


//////////////////
// WEBPACK FOOTER
// ./src/js/investor.js
// module id = 84
// module chunks = 5